import { FC, useCallback, useMemo, useState } from 'react'

import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'
import { useHandleEscKeyPress } from 'partner360/hooks/useHandleEscKeyPress'

import styles from '../../Status.module.scss'
import { StatusView } from '../statusView/StatusView'

import { AVAILABLE_STATUSES } from './configs'

interface IStatusEditModeProps {
  value: string
  onClick?: (newStatus: string) => void
}

export const StatusEditMode: FC<IStatusEditModeProps> = ({ value, onClick }) => {
  const [isOpen, setIsOpen] = useState(false)

  const statusesOptions = useMemo(() => {
    return AVAILABLE_STATUSES.filter((status) => status !== value)
  }, [value])

  const togglePopup = useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  const handleClosePopup = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const handleChangeStatus = useCallback(
    (newStatus: string) => {
      handleClosePopup()
      if (onClick) {
        onClick(newStatus)
      }
    },
    [handleClosePopup, onClick]
  )

  /** -------------------- Hooks ----------------------- */

  useHandleEscKeyPress({ cb: handleClosePopup, conditionForAddListener: isOpen })

  return (
    <div className={styles.root}>
      <AbsolutePopup
        verticalStartPosition={TPopupVertical.Bottom}
        visibilityCallback={() => {
          return isOpen
        }}
        popupContent={() => {
          return (
            <PopPaper className={styles.listWrapper}>
              {statusesOptions.map((it) => (
                <StatusView
                  key={it}
                  className={styles.listItem}
                  value={it}
                  onClick={handleChangeStatus}
                />
              ))}
            </PopPaper>
          )
        }}
      >
        <div className={styles.valueContainer} onClick={togglePopup}>
          <StatusView value={value} />
          <div className={styles.caretContainer}>
            <div className={styles.caretWrapper}>
              <i className="kbase kbase-omni-chevron-down" />
            </div>
          </div>
        </div>
      </AbsolutePopup>
    </div>
  )
}
